import { pollSandboxDetails } from "@/utils/apiFunctions";

export default {
	methods: {
		async pollSandbox(sandboxJobId, interval = 2000) {
			try {
				// eslint-disable-next-line no-constant-condition
				while (true) {
					const pollSandbox = await pollSandboxDetails(sandboxJobId);

					if (pollSandbox.data.data.status === "failed") {
						console.error(
							"Sandbox creation failed:",
							pollSandbox.data.data.error
						);
						return { success: false, error: pollSandbox.data.data.error };
					} else if (pollSandbox.data.data.status === "completed") {
						return {
							success: true,
							...pollSandbox.data.data,
						};
					}
					this.ideCurrentStatus = {
						status: pollSandbox.data.data.status,
						message: pollSandbox.data.data.message,
					};
					await new Promise((resolve) => setTimeout(resolve, interval));
				}
			} catch (error) {
				console.error("Polling error:", error);
				return { success: false, error: error.message };
			}
		},
	},
};
